module.exports = __webpack_public_path__ + "05_long_gold.46a68910.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/female/layer5/05_long_gold.png
// module id = 1Ybz
// module chunks = 0